import { AppAudioPlayer, SoundEffectKeys } from "../../../audio/AppAudioPlayer";
import { Interactive } from "../../../mixins/Interactive";
import { Showable } from "../../../mixins/Showable";
import GameScene from "../../../scenes/GameScene";
import { LobbyVariationItemsProps, OptionsItemLiveData, OptionsLiveData, TextureData } from "../../../types/types";
import { IconButton } from "../../../ui/IconButton";
import { ApplyMixins } from "../../../utils/ApplyMixins";
import { LoaderFileKeys } from "../../constant/AppConstants";
import { OptionsDataManager } from "../../managers/OptionsDataManager";
import { AppLocalization, LanguageId } from "../../localization/AppLocalization";
import { AppSettings } from "../../managers/AppSettings";
import { OptionsItemKeys } from "../../managers/LayoutDataManager";
import { ChoiceSelector, ChoiceSelectorEvents } from "../../views/ChoiceSelector";
import { LobbyLayout } from "../LobbyScreen";
import { VariationId } from "../TableScreen";


export interface LobbyVariationItem extends Showable, Interactive {}

export type LobbyVariationButtonProps = {
    x: number;
    y: number;
}

export class LobbyVariationItem extends Phaser.GameObjects.Container
{
    private static appliedMixins: boolean = false;
    
    public index: number;
    public variationId: VariationId;
    public bg: Phaser.GameObjects.Image;
    public logo: Phaser.GameObjects.Image;
    public btnHelp: IconButton;
    public btnStats: IconButton;
    public btnAIDiff: IconButton;
    public slider: ChoiceSelector;

    private bgTextureData: TextureData;
    private logoTextureData: TextureData;
    private itemProps: LobbyVariationItemsProps;
    // private onItemSliderChange: Function;
    private curButtonsInteractive: boolean;


    public Init(
        variationId: VariationId,
        bgTextureData: TextureData,
        logoTextureData: TextureData,
        itemProps: LobbyVariationItemsProps,
        // onShowComplete: TODO
    ): void
    {
        if (!LobbyVariationItem.appliedMixins) {
            ApplyMixins(LobbyVariationItem, [Showable, Interactive]);
            LobbyVariationItem.appliedMixins = true;
        }

        this.SetTweenProps(
            // showTweenConfig
            {
                onStart: this.OnShowStart.bind(this),
                // onStartParams: ,
                // onComplete: this.OnShowComplete.bind(this),
            },
            // hideTweenConfig
            {
                onStart: this.OnHideStart.bind(this),
            },
            // showTweenTargetProps
            {
                // alpha: 1,
                // y: ScreenManager.GetWindowRect().height,
            },
            // hideTweenTargetProps
            {
                // alpha: 0,
                // y: ScreenManager.GetWindowRect().height,
            },
        );

        this.variationId = variationId;
        this.bgTextureData = bgTextureData;
        this.logoTextureData = logoTextureData;
        this.itemProps = itemProps;
    }

    public Build(): void
    {
        // bg
        this.bg = this.scene.make.image({
            key: this.bgTextureData.texture, 
            frame: this.bgTextureData.frame,
        });
        this.add(this.bg);

        // logo
        this.logo = this.scene.make.image({
            key: this.logoTextureData.texture, 
            frame: this.logoTextureData.frame,
        });
        this.add(this.logo);

        // btnHelp
        this.btnHelp = new IconButton(this.scene, this.itemProps.btnHelp.x, this.itemProps.btnHelp.y);
        this.btnHelp.InitBase({
            out:{texture:LoaderFileKeys.ui, frame:"btn-round-bg-out.png"},
            over:{texture:LoaderFileKeys.ui, frame:"btn-round-bg-over.png"},
        }, false); // disabled by default
        this.btnHelp.InitIcon({
            // out:{texture:LoaderFileKeys.ui, frame:"icon-parchment-black.png"},
            out:{texture:LoaderFileKeys.ui, frame:"icon-questionmark-black.png"},
        }, null, 1.25);
        this.btnHelp.PostInit(40);
        // > btnHelpShadow
        const btnHelpShadow = this.scene.make.image({key:LoaderFileKeys.ui, frame:"circle-01-shadow.png"}).setScale(1.15);
        this.btnHelp.add(btnHelpShadow);
        this.btnHelp.sendToBack(btnHelpShadow);
        this.btnHelp.setScale(this.itemProps.btnHelp.scale);
        this.add(this.btnHelp);

        // btnStats
        this.btnStats = new IconButton(this.scene, this.itemProps.btnStats.x, this.itemProps.btnStats.y);
        this.btnStats.InitBase({
            out:{texture:LoaderFileKeys.ui, frame:"btn-round-bg-out.png"},
            over:{texture:LoaderFileKeys.ui, frame:"btn-round-bg-over.png"},
        }, false); // disabled by default
        this.btnStats.InitIcon({
            out:{texture:LoaderFileKeys.ui, frame:"icon-graph-black.png"},
        }, null, 1.25);
        this.btnStats.PostInit(40);
        // > btnStatsShadow
        const btnStatsShadow = this.scene.make.image({key:LoaderFileKeys.ui, frame:"circle-01-shadow.png"}).setScale(1.15);
        this.btnStats.add(btnStatsShadow);
        this.btnStats.sendToBack(btnStatsShadow);
        this.btnStats.setScale(this.itemProps.btnStats.scale);
        this.add(this.btnStats);

        // slider
        this.slider = new ChoiceSelector(this.scene, this.itemProps.slider.x, this.itemProps.slider.y);
        // this.slider.name = "LobbyVariationItem_ChoiceSelector";
        this.slider.Init(
            {
                texture:LoaderFileKeys.ui, frame:"btn-oval9-bg-out.png"
            },
            {
                out:{texture:LoaderFileKeys.ui, frame:"btn-round2-bg-out.png"},
                over:{texture:LoaderFileKeys.ui, frame:"btn-round2-bg-over.png"},
                disabled:{texture:LoaderFileKeys.ui, frame:"btn-round2-bg-disabled.png"}
            },
            {
                out:{texture:LoaderFileKeys.ui, frame:"btn-round3-bg-out.png"},
                over:{texture:LoaderFileKeys.ui, frame:"btn-round3-bg-over.png"},
                disabled:{texture:LoaderFileKeys.ui, frame:"btn-round2-bg-disabled.png"}
            }
        );
        this.slider.Build();
        this.slider.setScale(this.itemProps.slider.scale);
        this.add(this.slider);

        // > buttons interactivity
        // > listen to slider value change
        this.SetButtonsInteractive(false);
        
        
        // btnAIDiff (Test by Flo to AI level button directly into lobby)
        /*
        this.btnAIDiff = new IconButton(this.scene, this.itemProps.btnAIDiff.x, this.itemProps.btnAIDiff.y);
        this.btnAIDiff.InitBase({
            out:{texture:LoaderFileKeys.ui, frame:"btn-oval9-bg-out.png"},
            over:{texture:LoaderFileKeys.ui, frame:"btn-oval9-bg-over.png"},
        }, false); // disabled by default
        this.btnAIDiff.InitIcon({
            out:{texture:LoaderFileKeys.ui, frame:"icon-graph-black.png"},
        }, null, 1.25);
        this.btnAIDiff.PostInit(40);
        // > btnStatsShadow
        // const btnAIDiffShadow = this.scene.make.image({key:LoaderFileKeys.ui, frame:"circle-01-shadow.png"}).setScale(1.15);
        // this.btnAIDiff.add(btnAIDiffShadow);
        // this.btnAIDiff.sendToBack(btnAIDiffShadow);
        this.btnAIDiff.setScale(this.itemProps.btnAIDiff.scale);
        this.add(this.btnAIDiff);
        */
        

        // hide all items (no animation)
        this.OnShowStart();
    }

    public SetLayout(layout: LobbyLayout): void
    {
        // console.log("SetLayout",LobbyLayout[layout]);
        
        switch(layout) {
            case LobbyLayout.MULTI:
                // restart Show animation on all three items
                this.OnHideStart();
                this.OnShowStart();
                this.bg.visible = false;
                this.btnHelp.visible = 
                this.btnStats.visible = 
                this.slider.visible = false;
            break;
            case LobbyLayout.SINGLE:
                // restart Show animation on the single focused item
                this.OnHideStart();
                this.OnShowStart();
                this.bg.visible = true;
                this.btnHelp.visible = 
                this.btnStats.visible = 
                this.slider.visible = true;
            break;
        }
    }

    protected OnShowStart(): void
    {
        this.scene.tweens.add({
            targets: [this.bg],
            scaleX: 1,
            // delay: 250,
            duration: 500,
            ease: AppSettings.ease.genericShowHideEase,
        });
        this.scene.tweens.add({
            targets: [this.logo],
            scaleY: 1,
            // delay: 350,
            duration: 500,
            ease: AppSettings.ease.genericShowHideEase,
        });
        this.scene.tweens.add({
            targets: this.btnHelp,
            scale: this.itemProps.btnHelp.scale,
            x: this.itemProps.btnHelp.x,
            y: this.itemProps.btnHelp.y,
            delay: 100,
            duration: 500,
            ease: AppSettings.ease.genericShowHideEase,
        });
        this.scene.tweens.add({
            targets: this.btnStats,
            scale: this.itemProps.btnStats.scale,
            x: this.itemProps.btnStats.x,
            y: this.itemProps.btnStats.y,
            delay: 100,
            duration: 500,
            ease: AppSettings.ease.genericShowHideEase,
        });
        this.scene.tweens.add({
            targets: [this.slider],
            scale: this.itemProps.slider.scale,
            delay: 200,
            duration: 500,
            ease: AppSettings.ease.genericShowHideEase,
        });
    }

    protected OnHideStart(): void
    {
        this.scene.tweens.killTweensOf([this.bg, this.logo, this.btnStats, this.btnHelp, this.slider, this.btnHelp, this.btnStats]);
        this.bg.scaleX = 0;
        this.logo.scaleY = 0;
        this.btnStats.scale = 
        this.btnHelp.scale = 
        this.slider.scale = 0;
        this.btnHelp.x = this.itemProps.btnHelp.x + 300;
        this.btnStats.x = this.itemProps.btnStats.x - 300;
    }

    public SetButtonsInteractive(interactive: boolean): void
    {
        // console.log("SetButtonsInteractive", interactive);

        if (interactive != this.curButtonsInteractive) {
            this.btnHelp.SetInteractive(interactive);
            this.btnStats.SetInteractive(interactive);
            // slider
            this.slider.SetInteractive(interactive);
            if (interactive) {
                this.slider.GetEventEmitter().on(ChoiceSelectorEvents.CHANGE, this.OnSliderValueChange, this);
            }
            else {
                this.slider.GetEventEmitter().off(ChoiceSelectorEvents.CHANGE, this.OnSliderValueChange);
            }
            this.curButtonsInteractive = interactive;
        }
    }

    protected OnSliderValueChange(newValue: number): void
    {
        // console.log("OnSliderValueChange", newValue);

        // const itemLiveData: OptionsItemLiveData = OptionsDataManager.GetSharedData().itemsById[OptionsItemKeys.pointsPerGame];
        const itemLiveData: OptionsItemLiveData = OptionsDataManager.GetItemDataByItemId(OptionsItemKeys.pointsPerGame, this.variationId);
        itemLiveData.value = newValue;

        // dirty options screen
        (this.scene as GameScene).optionsScreen.SetDirty(true);

        // instantly react by saving to localStorage and updating views
        // resolve data change and update views (eg 'replace background tile')
        OptionsDataManager.ResolveLiveDataChange(this.variationId, true);
        
        // dispatch change
        // this.onItemSliderChange?.(this, newValue);

        // click
        AppAudioPlayer.PlaySfx(SoundEffectKeys.click4);
    }
}